/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends } from "tslib";
import { Base, String_$type, Boolean_$type, Number_$type, markType } from "igniteui-react-core";
import { SRProvider } from "igniteui-react-core";
import { TemplatedHtmlControl } from "./TemplatedHtmlControl";
import { FinancialChartRangeSelectorVisualData } from "./FinancialChartRangeSelectorVisualData";
import { List$1 } from "igniteui-react-core";
/**
 * @hidden
 */
var FinancialChartRangeSelectorView = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(FinancialChartRangeSelectorView, _super);
    function FinancialChartRangeSelectorView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.c = null;
        _this.e = null;
        return _this;
    }
    FinancialChartRangeSelectorView.prototype.f = function (a, b) {
        var c = new SRProvider(a);
        this.e = c;
        this.c.b = this.e;
    };
    FinancialChartRangeSelectorView.prototype.h = function (a, b, c) {
        TemplatedHtmlControl.n(".rangeSelector" + b + " span", "FinancialChart_RangeSelector_" + b, a, c);
    };
    FinancialChartRangeSelectorView.prototype.g = function (a) {
    };
    FinancialChartRangeSelectorView.prototype.d = function (a) {
        var b = new List$1(String_$type, 0);
        var c = new List$1(Boolean_$type, 0);
        var d = new List$1(Number_$type, 0);
        var e = new List$1(Number_$type, 0);
        var f = new List$1(Boolean_$type, 0);
        var g = new List$1(Number_$type, 0);
        var h = new List$1(Number_$type, 0);
        var k = this.a(a);
        for (var j = 0; j < k.length; j++) {
            var i = k[j];
            var l = i.parent() != null ? i.parent().getText() : "not found";
            l = l != null ? l.trim() : null;
            b.add(l);
            c.add1(i.getProperty("checked"));
            d.add(i.getOffset().left);
            e.add(i.getOffset().top);
            var m = i.parent().getNativeElement();
            var n = m.offsetParent != null;
            g.add(m.offsetWidth);
            h.add(m.offsetHeight);
            f.add(n);
        }
        ;
        return ((function () {
            var $ret = new FinancialChartRangeSelectorVisualData();
            $ret.buttonLabels = b.toArray();
            $ret.buttonsChecked = c.toArray();
            $ret.buttonLefts = d.toArray();
            $ret.buttonTops = e.toArray();
            $ret.buttonVisibilities = f.toArray();
            $ret.buttonWidths = g.toArray();
            $ret.buttonHeights = h.toArray();
            $ret.visibility = a.getStyleProperty("visibility");
            $ret.left = parseFloat(a.getStyleProperty("offsetLeft"));
            $ret.top = parseFloat(a.getStyleProperty("offsetTop"));
            $ret.width = parseFloat(a.getStyleProperty("offsetWidth"));
            $ret.height = parseFloat(a.getStyleProperty("offsetHeight"));
            return $ret;
        })());
    };
    FinancialChartRangeSelectorView.prototype.b = function (a) {
        return 5;
    };
    FinancialChartRangeSelectorView.prototype.i = function (a) {
    };
    FinancialChartRangeSelectorView.prototype.a = function (a) {
        return TemplatedHtmlControl.a(a, "input").toArray();
    };
    FinancialChartRangeSelectorView.$t = markType(FinancialChartRangeSelectorView, 'FinancialChartRangeSelectorView');
    return FinancialChartRangeSelectorView;
}(Base));
export { FinancialChartRangeSelectorView };
